// Quotes a raw value for embedding inside a PostgREST `.or()`/`.and()` filter
// expression. Required whenever the value is free text that could contain
// `,`, `(`, `)`, or `"` — those characters are structurally significant in
// the filter grammar and would otherwise corrupt the query (e.g. a chat or
// agent named "Foo, Bar" would break a `name.gt.Foo, Bar` cursor filter).
export function quotePostgrestValue(value: string): string {
  return `"${value.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}

// Escapes PostgREST `ilike` wildcard characters (`%`, `_`) and the escape
// character itself (`\`) so free-text search input is matched literally
// rather than as a pattern.
export function escapeIlike(value: string): string {
  return value.replace(/[\\%_]/g, (match) => `\\${match}`);
}

// Builds a `column.ilike."%term%"` fragment safe to embed inside a raw
// `.or()`/`.and()` filter string — escapes ILIKE wildcards first (so the
// search term matches literally) then quotes the whole pattern so
// structurally significant characters like `,` and `(` in the search term
// don't corrupt the surrounding filter grammar. Use this when OR-ing a
// search term across multiple columns; a single-column search should
// instead call `.ilike(column, pattern)` directly, which supabase-js
// escapes safely without needing this helper.
export function ilikeContainsFilter(column: string, term: string): string {
  const pattern = quotePostgrestValue(`%${escapeIlike(term)}%`);
  return `${column}.ilike.${pattern}`;
}
